import React, { useEffect, useState } from "react";
import "./TermsAndConditions.scss";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { useToast } from "../../context/ToastContext";

const TermsAndConditions = () => {
  const { policyTerms, general, labels } = useToast();
  const [loading, setLoading] = useState(false);

  const termsAndConditions = !!policyTerms?.termsAndConditions
    ? JSON.parse(policyTerms.termsAndConditions)
    : {};

  useEffect(() => {
    if (policyTerms === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [policyTerms]);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{`${general.GEN0001} | ${labels.LBL0146}`}</title>
        </Helmet>
        {loading ? (
          <section className="minHeight">
            <div className="loading-block">
              <i
                className="pi pi-spin pi-spinner"
                style={{ fontSize: "2rem" }}
              ></i>
              <p>{labels.LBL0069}</p>
            </div>
          </section>
        ) : (
          <div className="p-4 terms-conditions">
            <p>
              <strong>{termsAndConditions.title}</strong>
            </p>
            <div
              dangerouslySetInnerHTML={{
                __html: termsAndConditions.description,
              }}
            />
          </div>
        )}
      </HelmetProvider>
    </>
  );
};

export default TermsAndConditions;
